<div class="logo-details">
  <div class="logo-img pointer" [routerLink]="['/']"></div>
</div>
<div class="menu-details">
  <i class="ico-menu-1" id="btn" (click)="onCloseBtnClick()"></i>
</div>
<ul class="nav-list main">
  @if (user) {
    @for (item of menu; track item) {
      @if (item.url) {
        <ng-container *ngTemplateOutlet="itemTemplate, context: {$implicit: item}"></ng-container>
      }
      @if (item?.children) {
        <li>
          <a class="pointer" (click)="item['show'] = !item['show']">
            <i class="{{item?.icon}}"
              kendoTooltip
            title="{{item.name | translate}}"></i>
            <span class="links_name">{{item.name | translate}}</span>
          </a>
          <span class="tooltip">{{item.name | translate}}</span>
          @if (item['show']) {
            <ul class="nav-list sub">
              @for (subItem of item?.children; track subItem) {
                <ng-container *ngTemplateOutlet="itemTemplate, context: {$implicit: subItem}"></ng-container>
              }
            </ul>
          }
        </li>
      }
    }
    <ng-template #itemTemplate let-item>
      <li [canDoAction]="item?.permissions">
        <a [routerLink]="[item?.url]"
          [routerLinkActive]="'active'">
          <div class="collapsed-icon-container">
            <i class="{{item?.icon}}"
              kendoTooltip
            title="{{item?.name | translate}}"></i>
            @if (item?.collapsedLabel) {
              <div class="collapsed-label">{{item.collapsedLabel | translate}}</div>
            }
          </div>
          <span class="links_name">{{item?.name | translate}}</span>
        </a>
      </li>
    </ng-template>
  }
</ul>
<ul class="nav-list bottom">
  <li class="profile-avatar" [routerLink]="['/profile']">
    <kendo-avatar themeColor="none" [width]="'35px'" [height]="'35px'"
    [initials]="(user?.username + ' ' + user?.lastName) | initials" class="pointer"></kendo-avatar>
  </li>
  <li class="profile"
    title="{{ 'RELEASE_NOTES.TITLE' | translate }}"
    [routerLink]="['/release-notes']">
    <i class="ico-question-help-circle"></i>
  </li>
  <li class="profile"
    title="{{ 'CORE.COMMON.LOG_OUT' | translate }}">
    <div class="profile-details pointer" [routerLink]="['/profile']">
      <kendo-avatar themeColor="none" [width]="'35px'" [height]="'35px'"
      [initials]="(user?.username + ' ' + user?.lastName) | initials" class="pointer"></kendo-avatar>
      <div class="name-details">
        <div class="first-line">{{user?.username}}</div>
        <div class="second-line">{{user?.email}}</div>
      </div>
    </div>
    <i class="ico-logout pointer" id="log_out" (click)="logout()"></i>
  </li>
</ul>
